<template>
	<fragment>
		<class-header
			:subname="lecture.category"
			:name="lecture.lecName"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section ref="container" class="container" v-if="assign">
			<nav class="side-nav">
				<a @click="$router.push('/classroom/'+$route.params.lecId+'/assignment')" class="btn full-width round m-b-10">돌아가기</a>
			</nav>

			<div class="container-fiuld clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">과제 관리</div>
					<!--
					<div class="btn-group pull-right p-10 p-r-0">
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
					-->
				</div>
				<div class="white-box m-t-10 clearfix">
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<p class="f-18 m-b-0 text-bold text-blue">과제 - {{assign.assignName}}</p>
							<p class="f-14 m-b-0">제출기간 : {{assign.startDate | parseRegDate}} ~ {{assign.endDate | parseRegDate}}</p>
						</span>
						<span class="input-group-addon v-mid w140">
							제출 <span class="f-18 text-bold text-blue">{{assign.assignApplList.filter(e=>e.assignApplId).length}} / {{totalApply}}</span>
						</span>
						<span class="input-group-addon v-mid w60">
							<a class="modify" @click="modifyAssign">편집</a>
							<a class="del" @click="deleteAssign">삭제</a>
						</span>
					</div>
					<textarea class="full-width m-t-15" cols="30" rows="10" readonly :value="assign.info"></textarea>
					<ul>
						<li v-for="(item,idx) in assign.assignFileMappingList" :key="'assign-detail-file-list-'+idx">
							<a class="down-btn" :href="'/download/'+item.file.atchFileId" target="_blank">
								{{item.file.orignlFileNm}}
							</a>
						</li>
					</ul>
				</div>
				<div class="btn-group-box m-t-30 clearfix">
					<div class="btn-group pull-left clearfix">
						<div class="input-group w140 pull-left round m-r-5" style="margin-top: 1px;">
							<span class="input-group-addon v-mid">
								<input class="form-control m-b-0 round-left" type="text" placeholder="점수 입력" v-model="setAllPoint">
							</span>
							<span class="input-group-addon v-mid" style="width:50px;">
								<button class="btn bg-deepblue full-width text-white p-r-5 p-l-5 round-right"
									style="margin-top: -1px;" @click="setAll">일괄변경</button>
							</span>
						</div>
						<div class="select pull-left m-r-5">
							<a class="btn round" @click="mail">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="22" height="20" viewBox="0 0 22 20">
									<path class="msg-i"
										d="M262.519,1266.28a0.158,0.158,0,0,0,.019.08c0,0.02.019,0.06,0.019,0.08a0.473,0.473,0,0,1,.019.08,0.3,0.3,0,0,1,.038.08c0.019,0.02.019,0.04,0.038,0.06a0.107,0.107,0,0,1,.038.06l0.057,0.06,0.019,0.02a0.019,0.019,0,0,1,.019.02,0.447,0.447,0,0,0,.209.12,0.037,0.037,0,0,1,.038.02,0.91,0.91,0,0,0,.228.04h20.5a0.91,0.91,0,0,0,.228-0.04,0.037,0.037,0,0,0,.038-0.02,2.043,2.043,0,0,0,.209-0.12,0.019,0.019,0,0,0,.019-0.02l0.019-.02,0.057-.06a0.107,0.107,0,0,0,.038-0.06c0.019-.02.019-0.04,0.038-0.06a0.3,0.3,0,0,0,.038-0.08,0.1,0.1,0,0,0,.019-0.08c0-.02.019-0.06,0.019-0.08a0.473,0.473,0,0,0,.019-0.08v-18.46a0.792,0.792,0,0,0-.779-0.82H263.279a0.792,0.792,0,0,0-.779.82v18.38A0.1,0.1,0,0,1,262.519,1266.28Zm2.432-.94,5.756-7.25,2.394,1.76a0.752,0.752,0,0,0,.874,0l2.394-1.76,5.756,7.25H264.951Zm18.067-1.44-5.377-6.75,5.358-3.94v10.69h0.019Zm-18.96-15.26H283v2.58l-9.461,6.95-9.48-6.95v-2.58Zm0,4.57,5.357,3.94-5.357,6.75v-10.69Z"
										transform="translate(-262.5 -1247)"></path>
								</svg> 메일보내기
							</a>
						</div>
						<div class="select pull-left m-r-5">
							<a class="btn round" @click="sms">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="20" height="20" viewBox="0 0 20 20">
									<path class="sms-i"
										d="M386.428,1249.93a10,10,0,0,1,14.807,13.41,3.719,3.719,0,0,0,1.575,1.82,0.933,0.933,0,0,1-.268,1.76,5.3,5.3,0,0,1-.708.05h0a6.478,6.478,0,0,1-3.6-1.16A10,10,0,0,1,386.428,1249.93Zm0.8,13.34a8.909,8.909,0,0,0,10.763,1.38,0.59,0.59,0,0,1,.285-0.08,0.621,0.621,0,0,1,.348.11,5.414,5.414,0,0,0,3.138,1.16,5.789,5.789,0,0,1-1.714-2.37,0.561,0.561,0,0,1,.1-0.6A8.871,8.871,0,1,0,387.229,1263.27Zm2.082-9.57h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1253.7Zm0,2.73h8.38a0.569,0.569,0,0,1,.565.57,0.561,0.561,0,0,1-.565.56h-8.38a0.562,0.562,0,0,1-.566-0.56A0.573,0.573,0,0,1,389.311,1256.43Zm0,2.74h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1259.17Z"
										transform="translate(-383.5 -1247)"></path>
								</svg> 문자보내기
							</a>
						</div>
					</div>
					<!-- //end .btn-group -->
					<!--
					<div class="btn-group pull-right clearfix">
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 전체 다운로드
							</a>
						</div>
					</div>
					-->
					<!-- //end .btn-group -->
				</div>
				<table class="table2 table-condensed text-center m-t-15 m-b-30">
					<thead>
						<tr class="bg-lightgray">
							<th>
								<input id="table-allcheck" class="checkbox" type="checkbox" ref="checkAll" @change="checkAll">
								<label for="table-allcheck">체크버튼</label>
							</th>
							<th>수강생</th>
							<th>제출일</th>
							<th>과제</th>
							<th>제출</th>
							<th>점수</th>
						</tr>
					</thead>
					<tbody v-for="(item,idx) in assign.assignApplList" :item="item" :index="idx" :key="'assign-appl-list-for-'+assign.assignId+'-'+idx">
						<tr class="margin">
							<td colspan="6"></td>
						</tr>
						<tr>
							<td>
								<input :id="'assign-applicant-id-for='+$route.params.assignId+'-'+idx" class="checkbox" type="checkbox" @change="checkOne" v-model="item.checked_">
								<label :for="'assign-applicant-id-for='+$route.params.assignId+'-'+idx">체크버튼</label>
							</td>
							<td>{{item.mber ? item.mber.mberName : ''}}</td>
							<td>{{item.regDate | parseRegDate}}</td>
							<td>
								<a v-if="item.assignApplFile" :href="'/download/'+item.assignApplFile.atchFileId" target="_blank" style="color:#000;">{{item.assignApplFile.orignlFileNm}}</a>
								{{item.assignApplFile ? '' : '미제출'}}
							</td>
							<td>
								<input :id="'fileupload_for_'+idx" type="file" style="display: none;" :ref="'fileupload_for_'+idx" @change="fileUpload(idx)">
								<label :for="'fileupload_for_'+idx" class="btn-sm round">관리자 제출</label>
							</td>
							<td>{{item.score}}</td>
						</tr>
					</tbody>
				</table>
				<br>
				<br>
				<br><br>
				<br>
				<br>
			</div>
		</section>

		<modal-email :config="modals.ModalEmail" @close="modals.ModalEmail.show=false;" :key="hash(modals.ModalEmail)"></modal-email>
		<modal-sms :config="modals.ModalSms" @close="modals.ModalSms.show=false;" :key="hash(modals.ModalSms)"></modal-sms>
		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnGetLec from '../mixins/fnGetLec.js'
import fnUserList from '../mixins/fnUserList'

import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import axios from 'axios'
import server from '../statics/server.js'
import moment from 'moment'
import ModalEmail from '../modals/ModalEmail.vue'
import ModalSms from '../modals/ModalSms.vue'

export default {
	name: "ViewClassroomAssignmentDetail",
	mixins: [fnAdjustHeight, fnGetLec, fnUserList],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		ModalConfirm,
		ModalAlert,
		ModalEmail,
		ModalSms,
	},

	mounted: async function() {
		const { lecId } = this.$route.params;
		this.lecture = await this.getLecInfo(lecId);
		if(this.lecture.classroomOpt.indexOf("출결")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='출결')), 1 );
		if(this.lecture.classroomOpt.indexOf("과제")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=="과제")), 1 );
		if(this.lecture.classroomOpt.indexOf("설문")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='설문')), 1 );
		if(this.lecture.classroomOpt.indexOf("시험")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='시험')), 1 );
		//if(this.lecture.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
		this.refresh();
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			lecture: {},
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:false},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:false},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:true},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:false},
			],
			buttons : [
				{name:'새 과제 만들기', fn:()=>{this.$router.push('/classroom/'+this.$route.params.lecId+'/assignment/register/'+this.curriculumId)}}
			],
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
				ModalEmail: ModalEmail.default(),
				ModalSms: ModalSms.default(),
			},
			assignId: this.$route.params.assignId,
			totalApply: 0,
			setAllPoint: '',
			assign: {assignApplList:[]},
			students: [],
		}
	},

	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		// 과제 상세정보를 불러온다.
		refresh: function() {
			axios.post(server.addr()+server.api.ASSIGN+"/"+this.$route.params.assignId).then(response => {
				response.data.return.assignApplList.forEach(e => e.checked_=false);
				this.assign = response.data.return;
				// 이 강좌를 수강중인 회원 목록을 불러온다.
				axios.post(server.addr()+server.api.APPL, {lecId:this.$route.params.lecId, applStatus:"승인", certStatus:"미수료"}).then(response => {
					this.students = response.data.list;
					this.totalApply = response.data.filtered;
					// 이 학생을 순회하면서 assign.assignApplList를 채운다.
					this.students.forEach(mber => {
						// 이 학생이 assignApplList에 이미 있으면 통과
						if(this.assign.assignApplList.find(e=>e.mber&&e.mber.mberId==mber.mberId)) return;
						// 없으면 아직 과제를 제출하지 않은 학생으로 등록
						this.assign.assignApplList.push({mber, checked_:false});
					})
				});
			});
		},
		// 선택상태 토글
		checkOne: function() {
			if(this.assign.assignApplList.find(e=>!e.checked_)) {
				this.$refs.checkAll.checked = false;
			} else {
				this.$refs.checkAll.checked = true;
			}
		},
		checkAll: function() {
			if(this.$refs.checkAll.checked) {
				this.assign.assignApplList.forEach(e=>e.checked_=true);
			} else {
				this.assign.assignApplList.forEach(e=>e.checked_=false);
			}
		},
		// 모든 과제에 일괄 점수적용
		setAll: function() {
			let arr = [];
			this.assign.assignApplList.forEach(e => {
				if(e.checked_) {
					e.score=this.setAllPoint;
					arr.push({assignApplId:e.assignApplId, score:this.setAllPoint});
				}
			});
			if(arr.length) {
				axios.patch(server.addr()+server.api.ASSIGN_APPL, arr).then(() => this.refresh());
			}
		},
		mail: function() {
			let targets = this.assign.assignApplList.filter(a => a.checked_);
			if(targets.length==0) {
				this.modals.ModalAlert.msg = "전자우편을 수신할 대상을 선택하세요.";
				this.modals.ModalAlert.show = true;
				return;
			}
			targets = targets.map(t => t.mber);
			this.onMailForm(false, targets);
		},
		sms: function() {
			let targets = this.assign.assignApplList.filter(a => a.checked_);
			if(targets.length==0) {
				this.modals.ModalAlert.msg = "문자를 수신할 대상을 선택하세요.";
				this.modals.ModalAlert.show = true;
				return;
			}
			targets = targets.map(t => t.mber);
			this.onSMSForm(false, targets);
		},
		deleteAssign: function() {
			this.modals.ModalConfirm.msg = "과제를 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = () => {
				axios.delete(server.addr()+server.api.ASSIGN+"/"+this.assign.assignId).then(() => {
					this.$router.push("/classroom/"+this.$route.params.lecId+"/assignment");
				})
			}
			this.modals.ModalConfirm.show = true;
		},
		modifyAssign: function() {
			this.$router.push("/classroom/"+this.$route.params.lecId+"/assignment/"+this.$route.params.assignId+"/modify");
		},
		fileUpload: async function(idx) {
			const formData = new FormData();
			formData.append("file", this.$refs["fileupload_for_"+idx][0].files[0]);
			axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
				// 이미 과제가 업로드된 상태면, 업데이트
				if(this.assign.assignApplList[idx].assignApplId) {
					axios.patch(server.addr()+server.api.ASSIGN_APPL+"/"+this.assign.assignApplList[idx].assignApplId, [{assignApplFile:response.data}]).then(() => {
						this.refresh();
					});
				}
				// 과제가 업로드되지 않은 상태면, 인서트
				else {
					axios.put(server.addr()+server.api.ASSIGN_APPL, [{assignId:this.assignId, mberId:this.assign.assignApplList[idx].mber.mberId, assignApplFile:response.data, score:''}]).then(() => {
						this.refresh();
					});
				}
			});
		},
	},

	filters: {
		parseRegDate(date){
			if(date)
				return moment(date).format('YYYY-MM-DD')
			else
				return '';
		},
	}
}
</script>

<style>
.msg-i {
	fill: #999;
	fill-rule: evenodd;
}
.btn-group .btn:hover .msg-i {
	fill: #fff;
	fill-rule: evenodd;
}
.sms-i {
	fill: #999;
	fill-rule: evenodd;
}
.btn-group .btn:hover .sms-i {
	fill: #fff;
	fill-rule: evenodd;
}
</style>